import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsAiPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="ai"
    />
  );
}
